import { Component, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Vessel, VesselName, VesselsService, Voyage } from '../vessels.service';
import { MessageLevel, PgMessagesService } from '../../../shared/services/pg-messages.service';
import { Router } from '@angular/router';
import { PgTitleComponent } from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MaterialPgInputComponent } from 'src/app/shared/components/material-pg-input/material-pg-input.component';

import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';

@Component({
  selector: 'app-new-voyage',
  templateUrl: './new-voyage.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MaterialAutoCompleteComponent,
    MatSelectModule,
    MatButtonModule,
    MaterialPgInputComponent
  ]
})
export class NewVoyageComponent implements OnInit, PgTitleComponent {
  title = new EventEmitter<string>();

  vessels: Vessel[] = [];
  selectedVoyage: Voyage;
  organisations: Organisation[] = [];
  ports: Organisation[] = [];
  _selectedVessel!: Vessel;

  get selectedVessel() {
    return this._selectedVessel;
  }

  set selectedVessel(value: Vessel) {
    this._selectedVessel = value;
    this.selectedVoyage.vesselName = value.name!.name;
    this.selectedVoyage.vesselImo = value.imo;
  }

  set vesselOldName(value: VesselName | null | undefined) {
    if (value?.name !== undefined) {
      this.selectedVoyage.vesselName = value.name;
    } else {
      this.selectedVoyage.vesselName =
        this.selectedVessel?.name?.name ?? '';
    }
  }

  constructor(private _vesselsService: VesselsService,
              private _voyageService: VoyageServiceSpa,
              private _pgMessagesService: PgMessagesService,
              private _router: Router) {
    this.selectedVoyage = Voyage.create();
  }

  ngOnInit() {
    this.title.emit('New Voyage');
    this._vesselsService.getVessels().subscribe(vessels => {
      this.vessels = vessels;
    });
  }

  saveVoyage() {
    this._voyageService.addVoyage(this.selectedVoyage).then(results => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Save voyage for ${this.selectedVoyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['/vessels/voyage', results.data!.id]).then();
    });
  }

  vesselFormatter(vessel: Vessel) {
    const active = (vessel.active) ? 'Active' : '';
    return `${vessel.name!.name} ${vessel.imo} ${active}`;
  }

  vesselNameFormatter(vesselName: VesselName): string {
    return vesselName?.name ?? '';
  }

}
